import React from "react"
import PropTypes from "prop-types"

// type Props = {
//     // from search-new/components/Inline/LongInlinePresentation.js
//     children: React.Node,
// };

/** render the button that will expand the Inline onclick */
const DropDownOptions = (props) => (
    <div className="dropdown-options">
        <div className="shared-inline-dropdown">{props.children}</div>
    </div>
)

DropDownOptions.propTypes = {
    // from search-new/components/Inline/LongInlinePresentation.js
    children: PropTypes.node,
}

export default DropDownOptions
